export const neg =
  <T>(fn: (x: T) => boolean) =>
  (x: T): boolean =>
    !fn(x)
